import React from "react";

import { useAppSelector } from "~/store";

export function DevToolsOnly({ children }: { children: React.ReactNode }) {
  const areDevToolsEnabled = useAppSelector((state) => state.devTools);
  return areDevToolsEnabled ? <>{children}</> : null;
}
